import axios from "axios";
import { matchRoutes } from "react-router-dom";
import { BaseUrl } from "../ApiBaseUrl/ApiBaseUrl";
import { VENDOR_DETAILS } from "../ApiEndPoints/ApiEndPoints";

const TOKEN_KEY = "vms_vendor_token";
const SESSION_KEYS = [TOKEN_KEY, "encryptedUser", "userName", "userCompany", "persist:root"];
const REJECTED_STATUSES = [401, 402, 403];

let persistor;
let protectedRoutes = [];
let expiring = false;
let verification = null;

const isSessionRejected = (status) => REJECTED_STATUSES.includes(status);

const usedSessionToken = (config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  return !!token && String(config?.headers?.Authorization || "").includes(token);
};

const isSessionValid = () => {
  if (!verification) {
    verification = fetch(`${BaseUrl}${VENDOR_DETAILS}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}` },
    })
      .then((response) => !isSessionRejected(response.status))
      .catch(() => true)
      .finally(() => {
        verification = null;
      });
  }
  return verification;
};

const expireSession = async () => {
  if (expiring) return;
  expiring = true;

  persistor?.pause();
  await persistor?.flush();

  const language = localStorage.getItem("i18nextLng");
  localStorage.clear();
  if (language) {
    localStorage.setItem("i18nextLng", language);
  }
  window.location.replace("/?session=expired");
};

const clearStaleSession = async () => {
  if (expiring) return;
  expiring = true;

  persistor?.pause();
  await persistor?.flush();

  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
  window.location.reload();
};

const checkSessionOnLoad = async () => {
  if (!localStorage.getItem(TOKEN_KEY) || (await isSessionValid())) return;

  if (matchRoutes(protectedRoutes, window.location.pathname)) {
    expireSession();
  } else {
    clearStaleSession();
  }
};

export const setupSessionExpiry = (appPersistor, appProtectedRoutes) => {
  persistor = appPersistor;
  protectedRoutes = appProtectedRoutes;
  checkSessionOnLoad();

  axios.interceptors.response.use(undefined, async (error) => {
    if (!isSessionRejected(error.response?.status)) {
      return Promise.reject(error);
    }
    if (!expiring) {
      if (!usedSessionToken(error.config) || (await isSessionValid())) {
        return Promise.reject(error);
      }
      expireSession();
    }
    return new Promise(() => {});
  });
};